import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity.praksissteder.student';

const translations = generateTranslations(namespace, {
  title: {
    nb: 'Tilgjenglige praksissteder for { emne }',
    en: 'Available work placements for { emne }',
  },
  subtitle: {
    nb: 'Her velger du praksisplasser du ønsker deg, du kan rangere valgene dine etterpå',
    en: 'Here you can add work placements to your wish list, you may prioritize your choices later',
  },
  cancel: {
    nb: 'Tilbake til ønskeliste',
    en: 'Back to wish list',
  },
  readMore: {
    nb: 'Les mer',
    en: 'Read more',
  },
  praksisperiode: {
    nb: 'Praksisperiode',
    en: 'Practice period',
  },
  choosePraksissteder: {
    nb: 'Velg inntil {maxNum} praksissteder',
    en: 'Choose {maxNum} work placements',
  },
  choose: {
    nb: 'Velg',
    en: 'Choose',
  },
  unchoose: {
    nb: 'Fjern fra ønskelisten',
    en: 'Remove from wish list',
  },
  noChosenPraksissteder: {
    nb: 'Ingen praksissteder valgt',
    en: 'No work placements chosen',
  },
  numChosenPraksissteder: {
    nb: '{num}/{maxNum} praksissteder',
    en: '{num}/{maxNum} work placements',
  },
  dontShowAgain: {
    nb: 'Ikke vis denne meldingen igjen',
    en: "Don't show this message again",
  },
  wishListInfoHeader: {
    nb: 'Ønskeliste i praksis',
    en: 'Work placement wish list',
  },
  wishListInfo1: {
    nb: 'Hurra! Du har nå muligheten til å oppgi dine ønsker for hvor du vil tilbringe din praksisperiode. Hvilken praksisplass du får tildelt avhenger av om det er mange eller få som har ønsket seg til de samme stedene, og hvor mange studenter som har krav på spesiell tildeling av praksisplass.',
    en: 'You now have the opportunity to tell us where you wish to have your work placement. Your assigned work placement depends on the number of applicants there are and how many students are eligible for special placement.',
  },
  wishListInfo2: {
    nb: 'Etter at du har valgt ønsker på denne siden kan du endre dine prioriteringer på forrige side. Du kan nå forrige side ved å trykke på "Tilbake til ønskeliste" knappen øverst på siden.',
    en: 'After you\'ve chosen your wishes on this page you can change the priority of your wishes on the previous page. You can reach the previous page by clicking the "Back to wish list" button on top of the page.',
  },
  wishListInfo3: {
    nb: 'Dersom du i løpet av studietiden har flere praksisperioder, vil Arbeidslivsportalen huske om du fikk ønskene dine innfridd eller ikke, for hver praksisperiode. Dersom du ikke får ett av ønskene dine denne gangen, øker sannsynligheten for å få ett av ønskene i neste praksisperiode. Vi håper å kunne oppfylle et av dine ønsker slik at du får en lærerik og spennende praksisperiode. Lykke til!',
    en: 'If you have several work placements during the year, then Arbeidslivsportalen will remember whether you got your wishes granted, for each work placement period. If you did not get assigned to any of the placements you wished for this time, the likelihood that you will be assigned to a place you wish for the next time will increase. Good luck!',
  },
  understood: {
    nb: 'Jeg forstår',
    en: 'I understand',
  },
  prioritering: {
    nb: 'Prioritering:',
    en: 'Ranking:',
  },
  skjulPraksissteder: {
    nb: 'Skjul praksissteder',
    en: 'Hide work placements',
  },
  skjulOnskeliste: {
    nb: 'Skjul ønskeliste',
    en: 'Hide wish list',
  },
  helpBtn: {
    nb: 'Informasjon om ønskelisten',
    en: 'Information regarding the wish list',
  },
});

export default translations;
